(function () {
  'use strict';

  function selectTryOnSwatch(root, activeSwatch) {
    var selectedLabel = root.querySelector('[data-pdp-tryon-selected]');
    var swatches = root.querySelectorAll('[data-pdp-tryon-swatch]');
    var panels = root.querySelectorAll('[data-pdp-tryon-panel]');
    var index = activeSwatch.getAttribute('data-tryon-index');
    var shadeName = activeSwatch.getAttribute('data-shade-name');

    swatches.forEach(function (item) {
      var isActive = item.getAttribute('data-tryon-index') === index;
      item.classList.toggle('is-selected', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-tryon-index') === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (shadeName && selectedLabel) {
      selectedLabel.textContent = shadeName;
    }
  }

  function initTryOn(root) {
    if (!root || root.dataset.pdpTryonInit === 'true') return;
    root.dataset.pdpTryonInit = 'true';

    var swatches = root.querySelectorAll('[data-pdp-tryon-swatch]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectTryOnSwatch(root, swatch);
      });
    });

  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pdp-tryon]').forEach(initTryOn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
